import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { Form, Col, Button, FormLabel, Spinner, Container, Row } from "react-bootstrap";

// import logo_black from "";
import signBanner from "../../images/signBanner.svg";
import logo from "../../images/logo.png";
import toast from 'react-hot-toast';
import { API_BASE_URL, getBearerToken } from '../../functions';
import axios from 'axios';

const Forgot2 = () => {
  const [email, setemail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);




  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    const formData = new FormData();
    formData.append('email', email);
    axios
      .post(`${API_BASE_URL}/forgot-password`, formData, {
        headers: {
          Authorization: `Bearer ${getBearerToken()}`,
        },
      })
      .then((response) => {
        setLoading(false)
        // console.log('response', response);
        toast.success(response.data.message)
      })
      .then((result) => {
        setLoading(false);
        // console.log('result', result);
        toast.success(result.response.data.message)
      })
      .catch((error) => {
        setLoading(false);
        // console.log('error', error);
        toast.error(error.response.data.message)
      });
  };



  return (
    <>
      <Container>
        <Row className="justify-content-md-center mt-5">
          <Col className='loginform' xs={12} md={6}>
            <div className="text-center">
              <Link to={'/'} className={'w-100 d-block px-4'}><img src={logo} className={'img-fluid'} alt={'icon'} /></Link>
              <span className="login100-form-title">Forgot Password</span>
            </div>
            <Form className="validate-form w-100" onSubmit={(e) => handleSubmit(e)}>
              <Col xl={12} className="mb-3 mt-5">
                <Form.Group>
                  <div className="wrap-input100 validate-input" data-validate="Email Address">
                    <FormLabel className="0">Email Address</FormLabel>
                    <input className="input100" placeholder="demo@fasdf.com" required type="text" autoComplete="on" id="email" name="email" value={email} onChange={(e) => setemail(e.target.value)} />
                    <span className="focus-input100"></span>
                  </div>
                </Form.Group>
              </Col>
              <Button variant="" type="submit" id="submit" className="login100-form-btn" disabled={loading}>{!loading ? 'Forget Password' : <Spinner as='span' animation='border' size='md' role='status' aria-hidden='true' />}</Button>
              <p className="mt-4 text-center">Already have an account? <Link to={'/signin'} className="fontweight600 primarycolor fontsize14"> Login</Link></p>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Forgot2;